import { t } from 'i18next';

import {
  AgentMessageEventGuardrailCheckData,
  AgentMessageEventGuardrailDataOutput,
  AgentMessageEventOutput,
  AgentMessageEventType,
  GuardrailCheckStatus,
} from '../../../gamma-api';

const GUARDRAIL_EVENT_TYPE = AgentMessageEventType.Guardrail;

export type GuardrailEventData = AgentMessageEventGuardrailDataOutput;
export type GuardrailCheckData = AgentMessageEventGuardrailCheckData;

export const isGuardrailEvent = (event: AgentMessageEventOutput): boolean =>
  event.data.event_type === GUARDRAIL_EVENT_TYPE;

export const isGuardrailCheckBlocked = (data: GuardrailCheckData): boolean =>
  data.status === GuardrailCheckStatus.Block;

export const getGuardrailCheckStatus = (data: GuardrailCheckData): GuardrailCheckStatus =>
  data.status || (isGuardrailCheckBlocked(data) ? GuardrailCheckStatus.Block : GuardrailCheckStatus.Pass);

export const isGuardrailCheckWarning = (data: GuardrailCheckData): boolean => {
  const status = getGuardrailCheckStatus(data);
  return status === GuardrailCheckStatus.Audit || status === GuardrailCheckStatus.Error;
};

const getGuardrailCheckBaseTitle = (data: GuardrailCheckData): string => {
  const checkName = data.check_name?.trim();
  return checkName ? `${checkName} (${data.guardrail_type})` : data.guardrail_type;
};

export const getGuardrailCheckTargetTitle = (data: GuardrailCheckData): string => {
  const checkTarget = data.check_target;
  if (!checkTarget) {
    return '';
  }
  return t(`Agent: Guardrail check target: ${checkTarget}`);
};

export const getGuardrailCheckTitle = (data: GuardrailCheckData): string => {
  const checkTarget = getGuardrailCheckTargetTitle(data);
  const baseTitle = getGuardrailCheckBaseTitle(data);
  return checkTarget ? `${checkTarget}: ${baseTitle}` : baseTitle;
};
